import React from "react";

interface IProps {
  checked: boolean;
  onChange?: (checked: boolean) => void;
  className?: string;
  id?: string;
  size?: number; // Size of the radio button
  onClick?: (e: React.MouseEvent<HTMLInputElement>) => void;
  required?: boolean;
}

const CustomRadio = ({
  checked,
  onChange,
  className,
  id,
  // size = 18,
  onClick,
  required = false,
}: IProps) => {
  return (
    // <div
    //   className={`relative border w-[13px] lg:w-[1vw] aspect-square border-[#004540] rounded-full flex cursor-pointer items-center justify-center ${className || ""}`}
    //   onClick={() => onChange(!checked)}
    //   id={id || ""}
    // >
    //   {checked && (
    //     <div
    //       className="theme-bg-green rounded-full w-[calc(100%-3px)] h-[calc(100%-3px)]"
    //       // style={{ width: , height:  }}
    //     ></div>
    //   )}
    // </div>
    <input
      type="radio"
      checked={checked}
      onChange={(e) => {
        console.log(e.target.checked, "e.target.checked");
        console.log(checked, "checked");
        onChange?.(e.target.checked);
      }}
      onClick={(e) => {
        e.stopPropagation();
        onClick?.(e);
      }}
      id={id}
      className="w-[14px] 2xl:w-[18px] accent-[#00443F] aspect-square border border-[#00443f] rounded-sm 2xl:rounded flex items-center justify-center cursor-pointer"
      required={required}
    />
  );
};

export default CustomRadio;
